import React from 'react';
import withIcon from '../utilities/withIcon';

const IconChartDonutFilled = () => {
  return (
    <g>
      <path d="m8 .05a7.95 7.95 0 1 0 7.95 7.95 7.95 7.95 0 0 0 -7.95-7.95zm0 4.8891a3.0609 3.0609 0 1 1 -3.0609 3.0609 3.0609 3.0609 0 0 1 3.0609-3.0609zm0 9.3053a6.2444 6.2444 0 0 1 -6.2444-6.2444v-.0027a.5185.5185 0 1 1 1.0369 0l.0025.0027a5.205 5.205 0 1 0 5.205-5.2049v-1.0394a6.2444 6.2444 0 1 1 0 12.4887z" />
    </g>
  );
};

export default withIcon(IconChartDonutFilled);
